import { useEffect, RefObject } from 'react';
import { captureException } from '@sentry/browser';
import { loadRecordHit } from 'js/utils/loadRecordHit';
import {
  watchImpressions,
  Watcher,
} from 'js/utils/impressions/watchImpressions';

export function useShareImpressions(
  ref: RefObject<HTMLElement>,
  source: string,
  entityId: string | number,
  suffix = '',
): void {
  useEffect(() => {
    let stopped = false;
    let watchers: Watcher[] = [];

    const start = () => {
      if (stopped || document.hidden || !ref.current) return;
      document.removeEventListener('visibilitychange', start);
      const buttons = ref.current.matches('[data-share-channel]')
        ? [ref.current]
        : Array.from(
            ref.current.querySelectorAll<HTMLElement>('[data-share-channel]'),
          );
      watchers = buttons.map((button) =>
        watchImpressions(button, {
          source: `${source}${button.dataset.shareChannel}${suffix}`,
          entity_id: entityId,
          threshold: 0,
        }),
      );
    };

    void loadRecordHit()
      .then(() => {
        if (stopped || !window.Aedu?.hit_data?.id) return;
        if (document.hidden) {
          document.addEventListener('visibilitychange', start);
        } else {
          start();
        }
      })
      .catch(captureException);

    return () => {
      stopped = true;
      document.removeEventListener('visibilitychange', start);
      watchers.forEach((watcher) => watcher.stop());
    };
  }, [ref, source, entityId, suffix]);
}
